export default __webpack_public_path__ + "static/mg-p4-d26a50c67859b0a3f8c0b7ca11e1478d.jpg";